import {auth, db, googleProvider, twitterProvider, facebookProvider} from './firebase.js';

export const checkIfUsernameExits = (username, cb) => {
  db.collection("users").where("usernameLower", "==", username.toLowerCase()).get().then(function(user){
    console.log(user);
    if(user.empty){
      cb(false);
    }else{
      cb(true);
    }
  });
}

export const getUserByUid = (uid, cb) => {
  db.collection("users").doc(uid).get().then(function(user){
    cb(user.data());
  });
}

export const signout = () => {
  auth.signOut();
}

export const checkIfUserCreated = (cb) => {
  auth.onAuthStateChanged(user => {
    if (user) {
      db.collection("users").doc(user.uid).get().then(function(fullUser){
        if(fullUser.exists){
          cb(true);
        }else{
          cb(false);
        }
      });
    } else {
      cb(false);
    }
  });
}

export const changeUsername = (newUsername, cb) => {

  if(newUsername.length > 15){
    cb({status: -1, message: "Username can't be more than 15 characters"});
  }

  checkIfUsernameExits(newUsername, function(taken){
    if(taken){
      cb({status: -1, message: "Username taken"});
    }else{
      if(auth.currentUser !== null){
        db.collection("users").doc(auth.currentUser.uid).update({
          username: newUsername,
          usernameLower: newUsername.toLowerCase()
        }).then(function(result){
          cb(result);
        });
      }
    }
  });
}

export const createUser = (type, cb) => {

  var possibleChars = "abcdefghijklmnopqrstuvwxyz".split("");
  var randomUsername = "";

  for(var x = 0; x < 10; x++){
    randomUsername += possibleChars[Math.floor(Math.random() * possibleChars.length)];
  }

  checkIfUserCreated(function(userExists){
    if(!userExists){
      if(auth.currentUser !== null){
          var profilePic = "";
          if(type === "twitter.com"){
            profilePic = auth.currentUser.photoURL.replace("_normal", "");
          }
          if(type === "facebook.com"){
            profilePic = "https://graph.facebook.com/" + auth.currentUser.providerData[0].uid + "/picture?height=500";
          }
          db.collection("users").doc(auth.currentUser.uid).set({
            username: randomUsername,
            usernameLower: randomUsername.toLowerCase(),
            name: auth.currentUser.displayName,
            profilePic: profilePic,
            uid: auth.currentUser.uid,
            name: auth.currentUser.displayName
          }, {merge: true}).then(function(result){
            cb(result);
          });
        }
    }
  });
}

export const onAuthStateChanged = (cb) => {
  auth.onAuthStateChanged(user => {
    cb(user);
  });
}

export const isLoggedIn = (cb) => {
  var event = auth.onAuthStateChanged(user => {
    event();
    if (user) {
      cb(true, user);
    } else {
      cb(false, null);
    }
  });
}

export const getCurrentUser = (cb) => {
  auth.onAuthStateChanged(user => {
    if (user) {
      db.collection("users").doc(user.uid).get().then(function(fullUser){
        if(fullUser){
          cb(fullUser.data());
        }else{
          cb(null);
        }
      });
    } else {
      cb(null);
    }
  });
}

export const google = () => {
  return googleProvider;
}

export const twitter = () => {
  return twitterProvider;
}

export const facebook = () => {
  return facebookProvider;
}

export const signInWithPopup = (provider, cb) => {
  auth.signInWithPopup(provider).then(function(result){
    if(result.user.metadata.creationTime === result.user.metadata.lastSignInTime){
      createUser(provider.providerId, function(){
        cb(result.user, true);
      });
    }else{
        cb(result.user, false);
    }
  });
}



// WEBPACK FOOTER //
// ./src/firebase/auth.js